import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const SlackOrganizationsServiceContext = createContext(undefined)

const SlackOrganizationsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={SlackOrganizationsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/slack/organizations/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

SlackOrganizationsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useSlackOrganizationsService = () => {
  const context = useContext(SlackOrganizationsServiceContext)
  if (context === undefined) {
    throw new Error('SlackOrganizationsServiceContext was not provided. Make sure your component is a child of the SlackOrganizationsServiceProvider.')
  }
  return context
}

const useSlackOrganizationQuery = ({id, enabled, ...otherProps}) => {
  const morningNotesService = useSlackOrganizationsService()
  return useSimpleQuery({
    queryKey: `slack_organizations-get-${id}`,
    queryFn: async () => morningNotesService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {SlackOrganizationsServiceProvider, useSlackOrganizationsService, useSlackOrganizationQuery}
